<template>
  <div :class="{'hidden': !isShown}">
    <div class="card-container">
      <div class="card-header-container">
        <div>
          <div class="font-semibold text-xl mr-5">
            {{ startCase(detailData ? detailData.name : '') }}
          </div>
          <div v-if="detailData && !!detailData.tonnage">
            {{
              detailData
                ? detailData.tonnage
                  ? handleValidateAndFormatNumber(detailData.tonnage)
                  : '-'
                : '-'
            }} ton
          </div>
        </div>
        
        <vs-dropdown
          v-show="!isCheckPoint"
          class="ml-auto"
          vs-custom-content
          vs-trigger-click
        >
          <div
            class="close-button-bg"
          >
            <vs-icon
              icon="filter_alt"
              color="#7451D0"
              size="small"
            />
          </div>

          <vs-dropdown-menu class="loginx">
            <div style="min-width: 250px;">
              <select-with-multiple
                v-model="poi"
                class="px-2"
                :options="filterPoiOptions"
                placeholder="Select POI"
                :activate-search="true"
              />
            </div>
          </vs-dropdown-menu>
        </vs-dropdown>

        <div
          class="ml-2 close-button-bg"
          @click="$emit('close', false)"
        >
          <vs-icon
            icon="close"
            color="#7451D0"
            size="small"
          />
        </div>
      </div>
      <div v-show="!isCheckPoint">
        <div class="mt-3 p-3 flex justify-around items-center border rounded-md">
          <div
            class="flex gap-2 cursor-pointer"
            @click="detailData && detailData.total_incoming_fleets ? $emit('filterFleet', detailData.incoming_tug_ids) : ''"
          >
            <img
              class="vs-popup--img"
              :src="require('@/assets/shipo-icon-incoming-fleet.svg')"
            >
            <span class="self-center font-semibold">{{ detailData ? detailData.total_incoming_fleets : 0 }}</span>
            <span class="self-center">Incoming Fleets</span>
          </div>
          <div
            class="flex gap-2 cursor-pointer"
            @click="detailData && detailData.total_fleets_in_port ? $emit('filterFleet', detailData.tugs_in_port_ids) : ''"
          >
            <img
              class="vs-popup--img"
              :src="require('@/assets/shipo-icon-fleet-in-port.svg')"
            >
            <span class="self-center font-semibold">{{ detailData ? detailData.total_fleets_in_port : 0 }}</span>
            <span class="self-center">Fleets in Port</span>
          </div>
        </div>
        <div
          class="mt-3 p-3 flex justify-center items-center gap-5 rounded-md"
          :style="{
            backgroundColor: 
              detailData && detailData.water_level_color 
                ? detailData.water_level_color 
                : '#4DA1A9'
          }"
        >
          <img
            class="vs-popup--img"
            :src="require('@/assets/shipo-icon-water.svg')"
          >
          <div class="font-medium">
            <p>Water Level</p>
            <p class="py-2 text-white font-extrabold text-2xl">
              {{
                detailData
                  ? detailData.water_level
                    ? handleValidateAndFormatNumber(detailData.water_level, 2, '-')
                    : '-'
                  : '-'
              }} Meter
            </p>
            <p>From Ground</p>
          </div>
        </div>
        <div class="mt-3 p-3 border rounded-md">
          <div class="font-medium">
            Water Level per Day
          </div>
          <Bar
            class="h-64"
            :chart-data="waterLevelData"
            :chart-options="chartOptions"
          />
        </div>
        <div class="mt-3 p-3 rounded-md border flex items-center">
          <img
            class="vs-popup--img"
            :src="
              require(`@/assets/shipo-icon-weather-${
                detailData 
                  ? detailData.weather_status 
                    ? detailData.weather_status.toLowerCase() 
                    : 'sunny' 
                  : 'sunny'
              }.svg`)
            "
          >
          <div class="ml-5">
            <div class="capitalize">
              {{
                detailData
                  ? detailData.weather_status
                    ? detailData.weather_status.toLowerCase()
                    : 'N/A'
                  : 'N/A'
              }}
            </div>
            <div>
              {{
                detailData
                  ? detailData.weather_ambient_temp
                    ? detailData.weather_ambient_temp.toFixed(2)
                    : '-'
                  : '-'
              }}&deg; C
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="card-body-container">
        <div v-if="type === 'vessel'">
          <vessel-card :detail="detailData" />
        </div>
        <div v-else-if="type === 'tugboat'">
          <tugboat-card :detail="detailData" />
        </div>
        <div v-else>
          <port-card :detail="detailData" />
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import {
  BarController,
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  LineController,
  LineElement,
  PointElement,
  Title,
  Tooltip
} from "chart.js";
import { Bar } from "vue-chartjs/legacy";

// import PortCard from '@/components/mapShipDetail/port'
// import TugboatCard from '@/components/mapShipDetail/tugboat'
// import VesselCard from '@/components/mapShipDetail/vessel'
import SelectWithMultiple from "@/components/selectWithMultiple";
import {COLOR_TUGBOAT_DEFAULT} from "@/fixtures/Constants";

ChartJS.register(
  BarController,
  BarElement,
  LineController,
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Tooltip,
  Legend,
  Title
);

export default {
  components: {
    // PortCard,
    // TugboatCard,
    // VesselCard
    Bar,
    SelectWithMultiple
  },
  props: {
    isShown: {
      type: Boolean,
      default: () => false
    },
    type: {
      type: String,
      default: () => 'vessel'
    },
    detailData: {
      type: Object,
      default: () => ({
        name: '',
        tonnage: ''
      })
    },
    chartData: {
      type: Object,
      default: () => ({})
    },
    chartOptions: {
      type: Object,
      default: () => ({})
    },
    filterPoiOptions: {
      type: Array,
      default: () => ([])
    },
    isCheckPoint: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      sunny: 'sunny',
      cloudy: 'cloud',
      raining: 'rain',
      stormy: 'storm',
      foggy: 'fog',
      poi: [],
      options: [],
      waterLevelData: {}
    };
  },
  watch: {
    poi: {
      immediate: true,
      handler(val) {
        if (!!val) {
          const temp = this.cloneDeep(this.chartData)
          temp.datasets = [...temp.datasets]
          val
            .forEach(el => {
              const sortedData = el.value.water_level_past_7_days
                ?.sort((a, b) => new Date(a.water_level_timestamp) - new Date(b.water_level_timestamp))
                ?.map(v => v.water_level)

              temp.datasets.push({
                type: 'line',
                label: el.value.name,
                data: sortedData,
                borderColor: this.getRandomColor(1),
                fill: false,
                tension: 0.4,
                pointBackgroundColor: 'white'
              })
            })

          this.waterLevelData = temp
        }
      }
    },
    detailData: {
      handler() {
        this.waterLevelData = this.chartData
        this.poi = []
      }
    }
  },
  methods: {
    COLOR_TUGBOAT_DEFAULT() {
      return COLOR_TUGBOAT_DEFAULT
    },
    drawCardIcon(type) {
      switch (type) {
        case 'vessel':
          return require('../../assets/shipo-map-vessel.svg')
        case 'tugboat':
          return require('../../assets/shipo-map-tug.svg')
        case 'poi':
          return require('../../assets/shipo-map-poi-port.svg')
        default:
          return require('../../assets/shipo-popup-icon-close.svg')
      }
    },
    generateTitle() {
      if (this.type === 'tugboat') {
        return 'Tug & Barge'
      }

      return this.startCase(this.type)
    },
    getRandomColor(alpha = 0.7) {
      const r = Math.floor(Math.random() * 156) + 100;
      const g = Math.floor(Math.random() * 156) + 100;
      const b = Math.floor(Math.random() * 156) + 100;
      return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    }
  }
}
</script>

<style lang="scss" scoped>
.card-container {
  @apply p-3 flex flex-col rounded-lg overflow-auto;

  background-color: #fff;
  max-width: 30rem;
  max-height: 40rem;
}

.card-header-container {
  @apply flex flex-row items-center bg-white rounded-lg;
}

.card-body-container {
  @apply p-2 m-3 flex flex-col bg-white rounded-xl;
}

.icon-transparent-bg {
  background-color: rgba(255, 127, 87, 0.2);
  border-radius: 0.5rem;
}

.close-button-bg {
  @apply p-1 flex flex-row items-center cursor-pointer;
  background-color: #DBD1F6;
  border-radius: .5rem;
}
</style>
